const languageMixins = {
	created() {
		this.setPageIsLoading(true);

		this.getTranslations().then(() => {
			this.showPage = true;
			this.setPageIsLoading(false);
			this.onMainTranslationsLoaded();
		});
	},
	mounted() {
		appLog.log('languageMixins mounted');
	},
	data: function () {
		return {
			message: 'hello',
			data: 'abc',
			pageId: 'sample',
			showPage: false,
		};
	},
	props: {
		productLocalJsonUrl: {
			type: String,
			required: false,
		},
	},

	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		shopCdnUrl() {
			if (typeof window !== 'undefined' && window.shopCdnUrl) {
				const baseUrl = window.shopCdnUrl;
				return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
			}
			return 'https://s3.amazonaws.com/ackuretta.website/public/translations/'; // Fallback to remote CDN
		}, //https://cdn.ackuretta.com/public/translations/
		//https://s3.amazonaws.com/ackuretta.website/public/translations/
		//https://cdn.ackuretta.com/public/translations/
		currentLocale() {
			return i18n.locale;
		},
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions(['sayHi', 'someAction']),
		//...Vuex.mapActions('navBar', ['sayHi', 'closeAllMobileDropdowns']),
		async changeLocale(newLocale) {
			await this.getTranslations(newLocale);
		},

		onMainTranslationsLoaded() {},

		mergeObjects(target, source) {
			let result = JSON.parse(JSON.stringify(target));
			for (const key in source) {
				if (source.hasOwnProperty(key)) {
					if (typeof source[key] === 'object' && source[key] !== null) {
						if (!result[key] || typeof result[key] !== 'object') {
							result[key] = {};
						}
						result[key] = this.mergeObjects(result[key], source[key]);
					} else {
						result[key] = source[key];
					}
				}
			}

			return result;
		},

		async getTranslations(locale, pageId) {
			locale = locale ? locale : this.currentLocale;
			pageId = pageId ? pageId : this.pageId;
			appLog.log('getTranslations');
			if (this.productLocalJsonUrl) {
				return this.$store.dispatch('localization/fetchLocalTranslations', {
					productLocalJsonUrl: this.productLocalJsonUrl,
					locale: locale,
				});
			}
			return this.$store.dispatch('localization/fetchTranslations', {
				shopCdnUrl: this.shopCdnUrl,
				elementId: pageId,
				locale,
			});
			// let jsonData = await fetch(`${this.shopCdnUrl}ack.data.translations.${pageId}.${locale}.json?v=latest`)
			//   .then((response) => {
			//     if (!response.ok) {
			//       throw new Error('Failed to fetch translations')
			//     }
			//     appLog.log('fetchTranslations OK')
			//     return response.json()

			//   })

			//   let baseMessages = i18n.messages[locale]
			//   appLog.log(baseMessages)
			//   //let jsonData = response.json()
			//   appLog.log(jsonData)
			//   let allMessages = this.mergeObjects(baseMessages, jsonData)
			//   appLog.log(allMessages)
			//   i18n.setLocaleMessage(locale, allMessages)
			//   i18n.locale = locale
		},
	},
	beforeDestroy() {},
	watch: {
		currentLocale: {
			handler() {},
			deep: false,
		},
	},
};
